import {
    alert,
    mfa,
    reason,
    retrospectiveAnswer,
    risk,
    riskIndicator,
    ruleName,
    silverfortAction,
    userType
} from '../Controls/Filters/FiltersObjects';
import { PricingModules, PricingModulesStatus } from '../../context/contexts/PricingModuleContext';
import { isAnyEnablingModulesActive } from '../SystemSettings/hooks/lockedFeatures/utils';
import { RequiredModuleState } from '../SystemSettings/hooks/lockedFeatures/types';

type EnableByPricingModuleFn = (pricingModulesState: PricingModulesStatus) => boolean;


const enableSilverfortAction = (pricingModulesState: PricingModulesStatus) =>
    isAnyEnablingModulesActive(
        {
            [PricingModules.MFA_USERS]: RequiredModuleState.ON_PREM_ENABLED,
            [PricingModules.AUTHENTICATION_FIREWALL]: RequiredModuleState.ON_PREM_ENABLED
        },
        pricingModulesState
    );

export const enableRisk = (pricingModulesState: PricingModulesStatus) =>
    isAnyEnablingModulesActive(
        {
            [PricingModules.ITDR]: RequiredModuleState.ON_PREM_ENABLED,
            [PricingModules.ISPM]: RequiredModuleState.ON_PREM_ENABLED
        },
        pricingModulesState
    );

export const LOGS_FILTER_OBJECTS_BY_PRICING_MODULES: { [Key: string]: EnableByPricingModuleFn } = {
    [mfa.id]: (pricingModulesState: PricingModulesStatus) =>
        isAnyEnablingModulesActive(
            {
                [PricingModules.MFA_USERS]: RequiredModuleState.ON_PREM_ENABLED
            },
            pricingModulesState
        ),
    [retrospectiveAnswer.id]: (pricingModulesState: PricingModulesStatus) =>
        isAnyEnablingModulesActive(
            {
                [PricingModules.AUTHENTICATION_FIREWALL]: RequiredModuleState.ON_PREM_ENABLED
            },
            pricingModulesState
        ),
    [alert.id]: (pricingModulesState: PricingModulesStatus) =>
        isAnyEnablingModulesActive(
            {
                [PricingModules.MFA_USERS]: RequiredModuleState.ON_PREM_ENABLED
            },
            pricingModulesState
        ),
    [reason.id]: (pricingModulesState: PricingModulesStatus) =>
        isAnyEnablingModulesActive(
            {
                [PricingModules.MFA_USERS]: RequiredModuleState.ON_PREM_ENABLED,
                [PricingModules.AUTHENTICATION_FIREWALL]: RequiredModuleState.ON_PREM_ENABLED,
                [PricingModules.PRIVILEGED_ACCESS_SECURITY]: RequiredModuleState.ON_PREM_ENABLED
            },
            pricingModulesState
        ),
    [silverfortAction.id]: enableSilverfortAction,
    [ruleName.id]: (pricingModulesState: PricingModulesStatus) =>
        isAnyEnablingModulesActive(
            {
                [PricingModules.MFA_USERS]: RequiredModuleState.ON_PREM_ENABLED,
                [PricingModules.AUTHENTICATION_FIREWALL]: RequiredModuleState.ON_PREM_ENABLED
            },
            pricingModulesState
        ),
    [risk.id]: enableRisk,
    [riskIndicator.id]: enableRisk
};

export const LOGS_COLUMNS_BY_PRICING_MODULES: { [Key: string]: EnableByPricingModuleFn } = {
    ruleAction: enableSilverfortAction,
    risk: enableRisk
};

const SERVICE_ACCOUNT_OPTION_VALUE = userType.filterConfig.options[2].value;

export const LOGS_FILTER_VALUES_BY_PRICING_MODULES: {
    [FilterKey: string]: { [ValueKey: string]: EnableByPricingModuleFn };
} = {
    [userType.id]: {
        [SERVICE_ACCOUNT_OPTION_VALUE]: (pricingModulesState: PricingModulesStatus) =>
            isAnyEnablingModulesActive(
                {
                    [PricingModules.NHI_PROTECTION]: RequiredModuleState.ON_PREM_ENABLED,
                    [PricingModules.NHI_VISIBILITY]: RequiredModuleState.ON_PREM_ENABLED
                },
                pricingModulesState
            )
    }
};
